package eu.codlab.files

actual val RootPath = "."
